import { useAuthStore } from '@/stores/auth.store';
import { useSubscriptionStore } from '@/stores/subscription.store';

function nonEmptyString (value) {
    return typeof value === 'string' && value ? value : '';
}

function whiteLabelTitle (attributes) {
    return nonEmptyString(attributes?.whiteLabelSettings?.brandName)
        || nonEmptyString(attributes?.productName)
        || window.location.hostname;
}

export function getDefaultDocumentTitle () {
    const authStore = useAuthStore();
    if (authStore.isAuthenticated) {
        const subscriptionStore = useSubscriptionStore();

        return subscriptionStore.isAdoptEndUser
            ? whiteLabelTitle(subscriptionStore.trainingAttributes)
            : 'Pendo';
    }
    const attributes = authStore.unauthenticatedTrainingAttributes;

    return attributes?.whiteLabelSettings ? whiteLabelTitle(attributes) : 'Pendo';
}
